__turbopack_context__.v({
  "blok-big-title": "TextField-module__mGetDG__blok-big-title",
  "blok-subtitle": "TextField-module__mGetDG__blok-subtitle",
  "blok-title": "TextField-module__mGetDG__blok-title",
  "clearIcon": "TextField-module__mGetDG__clearIcon",
  "error": "TextField-module__mGetDG__error",
  "filled": "TextField-module__mGetDG__filled",
  "icon": "TextField-module__mGetDG__icon",
  "input": "TextField-module__mGetDG__input",
  "labelText": "TextField-module__mGetDG__labelText",
  "medium": "TextField-module__mGetDG__medium",
  "textField": "TextField-module__mGetDG__textField",
});
